import { Injectable } from '@angular/core';
import { Api } from '../api';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PasswordService extends Api {

  constructor(
    readonly http: HttpClient,
    readonly authService: AuthService
  ) {
    super(http, authService, 'password');
  }

  /**
   * ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ Ð·Ð°Ð¿ÑÐ¾Ñ Ð½Ð° Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ñ Ð¿Ð°ÑÐ¾Ð»Ñ
   * @param email Ð¿Ð¾ÑÑÐ° Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¹ ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÑ Ð¿Ð°ÑÐ¾Ð»Ñ
   */
  forgot(email: string): Observable<any> {
    return this.http.post(this.apiUrl + '/password/forgot', { email });
  }

  /**
   * ÐÑÐ¿ÑÐ°Ð²Ð»ÑÐµÑ Ð·Ð°Ð¿ÑÐ¾Ñ Ð½Ð° ÑÐ±ÑÐ¾Ñ Ð¿Ð°ÑÐ¾Ð»Ñ
   * @param token ÑÐ¾ÐºÐµÐ½ ÑÐµÑÑÐ¸Ñ ÑÐ±ÑÐ¾ÑÐ° Ð¿Ð°ÑÐ¾Ð»Ñ
   * @param password Ð½Ð¾Ð²ÑÐ¹ Ð¿Ð°ÑÐ¾Ð»Ñ
   */
  reset(token: string, password: string): Observable<any> {
    return this.http.get(this.apiUrl + '/password/reset', {
      params: {
        token,
        password
      }
    });
  }
}
